export default "__VITE_ASSET__BQuxTKeE__"